<div class="bit" [style]="style"  [ngClass]="bitClass" [matTooltip]="bit.tooltip"></div>
